import React, { createContext, useEffect, useState } from "react";
import MobileCategoryHeader from "@Components/Layout/Header/MobileCategorySection";
import { apiCategories } from "@Services/API/IndividualApi's/Category";
import { ICategory } from "@Interfaces/Api/category";
import CollectionsPage from "@Components/Pages/Collections/Category";
import { BannerContext } from "@Pages/index";
import { AllRootCategoryContext } from "@Pages/index";
import Loader from "@Components/Loader";
import { CategoryPageSkeleton } from "@Components/Loader/Skeleton";
import Head from "next/head";
import { Layout } from "@Components/Layout";
export const CategoryContext = createContext<any>(undefined);
export const ProductContext = createContext<any>({});

function Collection({
  allRootCategories,
  category,
}: {
  category: ICategory;
  allRootCategories: ICategory[];
}) {
  // useEffect(() => {
  //   getStatic();
  // }, []);
  // async function getStatic() {
  //   const response = await apiCategories.getHierarchy!(1, 10);
  //   const paths = response.map((item: { childCategories: any }) =>
  //   );
  // }
  // async function getStatic() {
  //   const response = await apiCategories.getHierarchy!(1, 10);
  //   const paths = response.map((category: { childCategories: any }) => ({
  //     params: {
  //       childCategories: category.childCategories.map((val: { slug: any }) => {
  //         return val.slug;
  //       }),
  //     },
  //   }));
  // }

  return (
    <>
      <Head>
        <title>{category.metaData?.title} - Econut</title>
        <meta name="description" content={category.metaData?.description} />
        <meta name="title" content={category.metaData?.title} />
        <meta
          name="keywords"
          content={category.metaData?.keywords.toString()}
        />
      </Head>
      <Layout>
        <AllRootCategoryContext.Provider value={allRootCategories}>
          {" "}
          {allRootCategories && <MobileCategoryHeader />}
        </AllRootCategoryContext.Provider>
        <BannerContext.Provider value={[{ media: category?.bannerImage }]}>
          {category ? (
            <CollectionsPage categories={category} />
          ) : (
            <Loader renderSkeleton={CategoryPageSkeleton} />
          )}
        </BannerContext.Provider>
      </Layout>
    </>
  );
}
// export const getStaticProps: GetStaticProps = async ({ params }) => {
//   const newCategory = `${params?.category}`;

//   const cmsData = await apiCategories.getSingleBySlug!(newCategory);
//   const category = cmsData;
//   const getallRootCategories = async () => {
//     try {
//       const filterObj = {
//         parent: "/",
//       };
//       const queryParam = `&filter=${JSON.stringify(filterObj)}`;
//       const response = await apiCategories.getAll!(1, 10, queryParam);
//       return response.data;
//     } catch (err) {
//       console.log(err);
//       return err;
//     }
//   };
//   const allRootCategories = await getallRootCategories();
//   return {
//     props: {
//       category: category,
//       allRootCategories,
//     },
//     // Next.js will attempt to re-generate the page:
//     // - When a request comes in
//     // - At most once every 10 seconds
//     revalidate: 3, // In seconds
//   };
// };

// export async function getStaticPaths() {
//   return {
//     paths: [],
//     fallback: true,
//   };
// }
export const getServerSideProps = async (context: {
  params: { category: string };
}) => {
  const newCategory = `${context.params.category}`;
  const cmsData = await apiCategories.getSingleBySlug!(newCategory);
  const category = cmsData;
  const filterObj = {
    parent: "/",
  };
  const queryParam = `&filter=${JSON.stringify(filterObj)}`;
  const response = await apiCategories.getAll!(1, 10, queryParam);
  if (!response) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      category: category,
      allRootCategories: response.data,
    }, // will be passed to the page component as props
  };
};
export default Collection;
